import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Notice, TopBlock } from 'app/shared/models/class/notice/notice';
import { environment } from 'environments/environment';
import { observable, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {

  detailsImage$ = new Subject<any>();
  noticeUpdate$ = new Subject<Notice>();

  private url = environment.apiUrl + '/Notice';

  constructor(private http: HttpClient) { }

  getNotices(): Observable<Notice[]> {
    return this.http.get<Notice[]>(`${this.url}/All`);
  }

  getTopNotices(): Observable<TopBlock[]> {
    return this.http.get<TopBlock[]>(`${this.url}/Top`);
  }

  postNotice(notice: Notice, thumbImage: null | File = null): Observable<any> {
    const data = new FormData();
    data.append('noticeString', JSON.stringify(notice));
    if (thumbImage) {
      data.append('file', thumbImage);
    }
    return this.http.post(`${this.url}`, data);
  }

  putNotice(notice: Notice, thumbImage: null | File = null): Observable<any> {
    const data = new FormData();
    data.append('noticeString', JSON.stringify(notice));
    if (thumbImage) {
      data.append('file', thumbImage);
    }
    return this.http.put(`${this.url}`, data);
  }

  putTopNotice(notice: any, thumbImage: null | File = null): Observable<any> {
    const data = new FormData();
    data.append('noticeString', JSON.stringify(notice));
    if (thumbImage) {
      data.append('file', thumbImage);
    }
    return this.http.put(`${this.url}/Top`, data);
  }

  delete(key: number): Observable<any> {
    return this.http.delete(`${this.url}/noticeKey?noticeKey=${key}`);
  }

}
